module.exports = __webpack_public_path__ + "files/57d4f81a5e04604310db661a9f6a3a61.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-120x120.png
// module id = 691
// module chunks = 27